import * as yup from 'yup';

import {
  ADMIN_REPORTS,
  ADVANCED_REPORTS,
  BALANCE_REPORTS,
  BASE_REPORTS,
  REPORT_TYPES,
  SERVICEDESK_REPORTS
} from '../type';
import {
  absenceCheckSchema,
  authSchema,
  auxGroupSchema,
  availabilitySchema,
  basePlanSchema,
  baseReportSchema,
  benefitsSchema,
  capplanSchema,
  compactDutyReportSchema,
  costOrgSchema,
  dayRosterSchema,
  detailOverviewSchema,
  dutyLineExtSchema,
  endingBenefitsSchema,
  hourPerPlanUnitSchema,
  leaveOrArrangementReportSchema,
  noTravelArrangementSchema,
  preferenceSchema,
  projectPlanningSchema,
  referenceDateSchema,
  requestReportSchema,
  sdEmployeeSchema,
  startAndEndDateSchema,
  startDateSchema,
  travelReportSchema
} from './schema';
import AuthSection from './sections/AuthSection';
import AuxGroupSection from './sections/AuxGroupSection';
import AvailabilitySection from './sections/AvailabilitySection';
import BasePlanSection from './sections/BasePlanSection';
import BaseSection from './sections/BaseSection';
import BenefitsSection from './sections/BenefitsSection';
import CapplanSection from './sections/CapplanSection';
import CompactDutySection from './sections/CompactDutySection';
import CostOrgSection from './sections/CostOrgSection';
import DayRosterSection from './sections/DayRosterSection';
import DetailOverViewSection from './sections/DetailOverViewSection';
import DutyLineExtSection from './sections/DutyLineExtSection';
import EndingBenefitsSection from './sections/EndingBenefitsSelection';
import HourPerPlanUnitSection from './sections/HourPerPlanUnitSection';
import NoTravelArrangementReportSection from './sections/NoTravelArrangementReportSection';
import PreferenceSection from './sections/PreferenceSection';
import ReferenceDateSection from './sections/ReferenceDateSection';
import RequestReportSection from './sections/RequestReportSection';
import SDEmployeeSection from './sections/SDEmployeeSection';
import StartDateSection from './sections/StartDateSection';
import TravelReportSection from './sections/TravelReportSection';
import ValidFromAndToSection from './sections/ValidFromAndToSection';
import AbsenceCheckSection from './sections/AbsenceCheckSection';
import ProjectPlanningSection from './sections/ProjectPlanningSection';

export const useActualFormProperties = (
  rowItemName: REPORT_TYPES | undefined,
  forcedDefaultReportType?: REPORT_TYPES
) => {
  if (forcedDefaultReportType) {
    return {
      schema: projectPlanningSchema,
      Component: ProjectPlanningSection
    };
  }
  switch (rowItemName) {
    case BASE_REPORTS.WEEK_REPORT:
      return {
        schema: baseReportSchema,
        Component: BaseSection
      };
    case BASE_REPORTS.DUTY_REPORT_COMP:
      return {
        schema: compactDutyReportSchema,
        Component: CompactDutySection
      };
    case BASE_REPORTS.PROJECTPLANNING_REPORT:
      return {
        schema: projectPlanningSchema,
        Component: ProjectPlanningSection
      };
    case BASE_REPORTS.DAY_ROSTER:
      return {
        schema: dayRosterSchema,
        Component: DayRosterSection
      };
    case BASE_REPORTS.REQUEST_REPORT:
      return {
        schema: requestReportSchema,
        Component: RequestReportSection
      };
    case BASE_REPORTS.AVAILABILITY:
      return {
        schema: availabilitySchema,
        Component: AvailabilitySection
      };
    case BASE_REPORTS.HOURMANAGEMENT_REPORT:
      return {
        schema: baseReportSchema,
        Component: BaseSection
      };
    case BASE_REPORTS.DUTY_CODE_REPORT:
      return {
        schema: referenceDateSchema,
        Component: ReferenceDateSection
      };
    case BASE_REPORTS.PREFERENCES:
      return {
        schema: preferenceSchema,
        Component: PreferenceSection
      };
    case BASE_REPORTS.LEAVE_REQUEST:
      return {
        schema: leaveOrArrangementReportSchema,
        Component: ValidFromAndToSection
      };
    case BASE_REPORTS.ORGANIZATIONAL_UNIT_DISTRIBUTION:
      return {
        schema: referenceDateSchema,
        Component: ReferenceDateSection
      };
    case ADVANCED_REPORTS.ARRANGEMENT_REPORT:
      return {
        schema: leaveOrArrangementReportSchema,
        Component: ValidFromAndToSection
      };
    case ADVANCED_REPORTS.AUTHORIZATION_ADV_REPORT:
      return {
        schema: authSchema,
        Component: AuthSection
      };
    case ADVANCED_REPORTS.BASE_PLAN:
      return {
        schema: basePlanSchema,
        Component: BasePlanSection
      };
    case ADVANCED_REPORTS.BENEFITS:
      return {
        schema: benefitsSchema,
        Component: BenefitsSection
      };
    case ADVANCED_REPORTS.CAPPLAN:
      return {
        schema: capplanSchema,
        Component: CapplanSection
      };
    case ADVANCED_REPORTS.TRAVEL_REPORT:
      return {
        schema: travelReportSchema,
        Component: TravelReportSection
      };
    case ADVANCED_REPORTS.MISSING_FLOW:
      return {
        schema: leaveOrArrangementReportSchema,
        Component: ValidFromAndToSection
      };
    case ADVANCED_REPORTS.DUTY_OVERLAP:
      return {
        schema: leaveOrArrangementReportSchema,
        Component: ValidFromAndToSection
      };
    case ADVANCED_REPORTS.ENDING_BENEFITS:
      return {
        schema: endingBenefitsSchema,
        Component: EndingBenefitsSection
      };
    case ADVANCED_REPORTS.HOURS_PER_PLANUNIT:
      return {
        schema: hourPerPlanUnitSchema,
        Component: HourPerPlanUnitSection
      };
    case ADVANCED_REPORTS.PUBLISH_REPORT:
      return {
        schema: yup.object(),
        Component: () => <></>
      };
    case ADVANCED_REPORTS.NO_TRAVEL_ARRANGEMENT_REPORT:
      return {
        schema: noTravelArrangementSchema,
        Component: NoTravelArrangementReportSection
      };
    case ADVANCED_REPORTS.DUTY_LINE_EXT:
      return {
        schema: dutyLineExtSchema,
        Component: DutyLineExtSection
      };
    case ADVANCED_REPORTS.REQUEST_RESPONSE:
      return {
        schema: hourPerPlanUnitSchema,
        Component: HourPerPlanUnitSection
      };
    case ADMIN_REPORTS.FLEX_TRAVEL_ARRANGEMENT:
      return {
        schema: leaveOrArrangementReportSchema,
        Component: ValidFromAndToSection
      };
    case ADMIN_REPORTS.TRAVEL_EXPENSE_CLAIM_REPORT:
      return {
        schema: leaveOrArrangementReportSchema,
        Component: ValidFromAndToSection
      };
    case ADMIN_REPORTS.FUNCTION_REPORT:
      return {
        schema: referenceDateSchema,
        Component: ReferenceDateSection
      };
    case ADMIN_REPORTS.BALANCE_BUDGET_OVERVIEW:
      return {
        schema: yup.object(),
        Component: () => <></>
      };
    case ADMIN_REPORTS.BALANCE_BUDGET_TO_HR:
      return {
        schema: startAndEndDateSchema,
        Component: ValidFromAndToSection
      };
    case ADMIN_REPORTS.STATUS_DUTY:
      return {
        schema: startDateSchema,
        Component: StartDateSection
      };
    case ADMIN_REPORTS.YEAR_CLOSURE:
      return {
        schema: referenceDateSchema,
        Component: ReferenceDateSection
      };
    case ADMIN_REPORTS.BUH_SETTINGS:
      return {
        schema: yup.object(),
        Component: () => <></>
      };
    case ADMIN_REPORTS.EMPLOYER:
      return {
        schema: referenceDateSchema,
        Component: ReferenceDateSection
      };
    case ADMIN_REPORTS.ACCOUNT_GROUPS_REPORT:
      return {
        schema: yup.object(),
        Component: () => <></>
      };
    case ADMIN_REPORTS.COST_CENTERS_ORG:
      return {
        schema: costOrgSchema,
        Component: CostOrgSection
      };
    case ADMIN_REPORTS.AUX_VALUE:
      return {
        schema: auxGroupSchema,
        Component: AuxGroupSection
      };
    case ADMIN_REPORTS.DUTY_TYPE:
      return {
        schema: referenceDateSchema,
        Component: ReferenceDateSection
      };
    case ADMIN_REPORTS.ABSENCE_CHECK:
      return {
        schema: absenceCheckSchema,
        Component: AbsenceCheckSection
      };
    case ADMIN_REPORTS.AUTHORIZATION_REPORT:
      return {
        schema: authSchema,
        Component: AuthSection
      };
    case BALANCE_REPORTS.DETAIL_OVERVIEW:
      return {
        schema: detailOverviewSchema,
        Component: DetailOverViewSection
      };
    case BALANCE_REPORTS.BALANCE_REPORT:
      return {
        schema: referenceDateSchema,
        Component: ReferenceDateSection
      };
    case SERVICEDESK_REPORTS.HOUR_BALANCE_REPORT:
      return {
        schema: startDateSchema,
        Component: StartDateSection
      };
    case SERVICEDESK_REPORTS.SD_EMPLOYEE:
      return {
        schema: sdEmployeeSchema,
        Component: SDEmployeeSection
      };
    default:
      return {
        schema: yup.object(),
        Component: () => <></>
      };
  }
};
